var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bar',{staticStyle:{"height":"300px"},attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }